/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { StepStatus } from '../enums';
import { GetTimeElapsedForRecheckButtonResponse } from '../../../../../common/types/apiShapes';
import config from '../../../config';

interface isRecheckStatusButtonDisabledParameters {
  stepStatus: StepStatus | null;
  selectedTransmissionHistoryId: string | null;
  isCurrentSubmissionSelected: boolean;
  isCheckingTransmissionStatus: boolean;
  timeElapsedForRecheckButton: GetTimeElapsedForRecheckButtonResponse | undefined;
  isRecheckStatusClicked: boolean;
}

// stateSubmissionId is 'null' when step fails
const isRecheckStatusButtonDisabled = ({
  stepStatus,
  selectedTransmissionHistoryId,
  isCurrentSubmissionSelected,
  isCheckingTransmissionStatus,
  timeElapsedForRecheckButton,
  isRecheckStatusClicked,
}: isRecheckStatusButtonDisabledParameters) =>
  isRecheckStatusClicked ||
  (selectedTransmissionHistoryId && !isCurrentSubmissionSelected) ||
  isCheckingTransmissionStatus ||
  (timeElapsedForRecheckButton &&
    timeElapsedForRecheckButton.timeElapsed <= Number(config.recheckStatusCoolDownMinutes)) ||
  stepStatus === StepStatus.INITIATED ||
  stepStatus === null;

export default isRecheckStatusButtonDisabled;
